// extracted by mini-css-extract-plugin
export default {"headerUser":"User_headerUser__3BOod","layoutForm":"User_layoutForm__0y9tY","inputForm":"User_inputForm__FLF0Z"};